var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "factory_861164_1_",
    "data-name": "factory_861164 (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.984,
    height: 20.34,
    viewBox: "0 0 18.984 20.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M34.816,8.861a.339.339,0,0,0-.336,0l-.933.518L33.289.329A.339.339,0,0,0,32.95,0H30.577a.339.339,0,0,0-.339.33L29.922,11.39l-1.04.576V9.153a.339.339,0,0,0-.5-.3l-5.6,3.11V9.153a.339.339,0,0,0-.5-.3l-6.1,3.39a.339.339,0,0,0-.175.3V20a.339.339,0,0,0,.339.339H34.645A.339.339,0,0,0,34.984,20V9.153A.339.339,0,0,0,34.816,8.861ZM30.906.678H32.62l.02.678H30.887Zm-.039,1.356h1.792l.22,7.712-2.269,1.26ZM25.153,19.662H23.119V17.967h2.034Zm2.712,0H25.831V17.967h2.034Zm6.441,0H28.543V17.628a.339.339,0,0,0-.339-.339H22.78a.339.339,0,0,0-.339.339v2.034H16.678V12.742L22.1,9.729v2.814a.339.339,0,0,0,.5.3l5.6-3.11v2.814a.339.339,0,0,0,.5.3l3.2-1.776,1.486-.825.915-.508Z",
    transform: "translate(-16 0)",
    fill: "#7b7bff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(1.695 13.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M59.051,320H56.339a.339.339,0,0,0-.339.339v1.356a.339.339,0,0,0,.339.339h2.712a.339.339,0,0,0,.339-.339v-1.356A.339.339,0,0,0,59.051,320Zm-.339,1.356H56.678v-.678h2.034Z",
    transform: "translate(-56 -320)",
    fill: "#7b7bff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(7.797 13.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M203.051,320h-2.712a.339.339,0,0,0-.339.339v1.356a.339.339,0,0,0,.339.339h2.712a.339.339,0,0,0,.339-.339v-1.356A.339.339,0,0,0,203.051,320Zm-.339,1.356h-2.034v-.678h2.034Z",
    transform: "translate(-200 -320)",
    fill: "#7b7bff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(13.899 13.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M347.051,320h-2.712a.339.339,0,0,0-.339.339v1.356a.339.339,0,0,0,.339.339h2.712a.339.339,0,0,0,.339-.339v-1.356A.339.339,0,0,0,347.051,320Zm-.339,1.356h-2.034v-.678h2.034Z",
    transform: "translate(-344 -320)",
    fill: "#7b7bff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.8c802ced4dad8bd90d30bcc8f1bab406.svg";
export { ForwardRef as ReactComponent };